module.exports = __webpack_public_path__ + "img/keith.3f61b758.jpg";